import React, { useEffect, useState } from "react"
import styled from "@emotion/styled"
import { colors } from "../../../../../../../library/constants/styles/colors"
import DeleteForeverOutlined from "@material-ui/icons/DeleteForeverOutlined"
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown"
import KeyboardArrowUp from "@material-ui/icons/KeyboardArrowUp"
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator"
import Button from "@material-ui/core/Button/Button"
import AddOutlined from "@material-ui/icons/AddOutlined"
import QuestionForm from "../questionForm/questionForm"
import EditOutlined from "@material-ui/icons/EditOutlined"
import "./stepForm.scss"
import FileLoader from "../../../../../../../components/formComponents/fileLoader"
import { withSnackbar } from "notistack"
import StepProductsDialog from "../stepProductsDialog/stepProductsDialog"
import { omit } from "lodash"
import { devices } from "../../../../../../../library/constants/styles/responsive"
import { MultipleTextField } from "../../../../../../../components/formComponents"
import { urlValidation } from "../../../../../../../library/utils/validators"
import TimeDurationPicker from "../../../../../../../components/formComponents/timeDurationPicker"
import UnitInfo from "./components/unitInfo"
import TrueFalseQuestion from "./components/questionInfo/trueFalseQuestion"
import { isLast } from "../../../../../../../library/utils/arrays"
import MultipleChoiceQuestion from "./components/questionInfo/multipleChoiceQuestion"
import TextAnswerQuestion from "./components/questionInfo/textAnswerQeustion"
import FillBlankQuestion from "./components/questionInfo/fillBlankQuestion"
import MatchingQuestion from "./components/questionInfo/matchingQuestion"
import StandardPicker from "../../../../../../../components/v2/inputs/pickers/standardPicker"

const Container = styled.div`
  padding: 15px;
  border-radius: 2px;
  background-color: ${colors.white};
  box-shadow: 0 0 2px 0 ${colors.black12};

  &:not(:last-child) {
    margin-bottom: 15px;
  }
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  p {
    max-width: 575px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @supports (display: grid) {
      flex: 1;
    }

    @media ${devices.xs} {
      max-width: 200px;
    }
  }
`

const Status = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.black54};
`

const Content = styled.div`
  padding-top: 15px;
`

const StepForm = ({
  step,
  stepNumber,
  createStep,
  updateStep,
  deleteStep,
  disabled,
  ...rest
}) => {
  const [open, setOpen] = useState(!step.id)
  const [canDelete] = useState(!!step.id)

  const [values, setValues] = useState({
    name: step.name,
    description: step.description,
    standards: step.standards || [],
    questions: step.questions.map((q) =>
      omit(q, ["user_answer_options", "user_answer_text"])
    ),
    blobs: step.blobs || [],
    blobsInfo: step.blobs || [],
    links: step.links || [],
    isLive: step.is_live || true,
    liveMeetingType: step.live_meeting_type || "1",
    dates: step.dates || [],
    learnersNumber: step.learnersNumber || 1,
    location: step.location || "",
    meetingLink: step.meeting_link || "",
    time: step.time || "",
  })

  const [openQuestionDialog, setOpenQuestionDialog] = useState(false)

  const [questionToEdit, setQuestionToEdit] = useState({
    question: undefined,
    index: undefined,
  })

  const [products, setProducts] = useState({
    open: false,
    list: step.products.map((p) => p.id) || [],
    dataList: step.products || [],
  })

  useEffect(() => {
    ValidatorForm.addValidationRule("isLink", (value) => urlValidation(value))
  }, [])

  const toggle = () => {
    setOpen(!open)
  }

  const handleChange = (name) => (event) => {
    if (name === "isLive") {
      return setValues({ ...values, [name]: event.target.checked })
    }
    setValues({ ...values, [name]: event.target.value })
  }

  const handleClickOpen = (type, question, index) => {
    if (type === "edit") {
      setQuestionToEdit({ question, index })
    } else {
      setQuestionToEdit({ question: undefined, index: undefined })
    }

    setOpenQuestionDialog(true)
  }

  const handleClose = () => {
    setOpenQuestionDialog(false)
  }

  const saveQuestion = ({ index, question }) => {
    const questionsUpdated =
      index !== undefined
        ? values.questions.map((item, i) => {
            return i === index ? question : item
          })
        : [...values.questions, question]

    setValues({ ...values, questions: questionsUpdated })
    setQuestionToEdit({ question: undefined, index: undefined })
  }

  const deleteQuestion = (index) => {
    const updatedQuestions = values.questions.filter((item, i) => i !== index)
    setValues({ ...values, questions: updatedQuestions })
  }

  const handleFileInputOpen = (id) => {
    document.getElementById(id).click()
  }

  const setBlobs = ({ blobs, blobsInfo }) => {
    setValues({ ...values, blobs, blobsInfo })
  }

  const openProductsDialog = () => {
    setProducts({ ...products, open: true })
  }

  const closeProductsDialog = () => {
    setProducts({ ...products, open: false })
  }

  const addProduct = (product) => {
    const dataList = [...products.dataList, product]
    const list = [...products.list, product.id]
    setProducts({ ...products, list, dataList })
  }

  const deleteProductFromList = async (id) => {
    const dataList = products.dataList.filter((p) => p.id !== id)
    const list = products.list.filter((item) => item !== id)
    setProducts({ ...products, list, dataList })
  }

  const deleteProduct = async (product_id) => {
    // await rest.deleteProduct({knowmix_step_id: step.id, product_id});
    await deleteProductFromList(product_id)
  }

  const processDeleteStep = async () => {
    await deleteStep(step.id)
  }

  const processSaveStep = async () => {
    const { name, description, blobs, questions, links, time } = values
    const attachments = blobs.map((item) => item.id)

    const data = {
      id: step.id || undefined,
      name,
      description,
      attachments,
      attachmentsDataList: values.blobs,
      standards: values.standards.map((s) => s.id),
      standardsDataList: values.standards,
      questions: questions,
      productsDataList: products.dataList,
      products: products.list,
      time,
      links,
    }

    // !!step.id ? await updateStep({step: data}) : await createStep({step: data});
    if (!!step.id) {
      await updateStep({ step: data })
    } else {
      await createStep({ step: data })
    }
    // await rest.stepsList({id: parseInt(props.match.params.knowmixId)});
  }

  const composeQuestionTemplate = (question, index) => {
    const getTemplate = () => {
      switch (question.type) {
        case 1:
          return <TrueFalseQuestion question={question} index={index} />

        case 2:
          return (
            <MultipleChoiceQuestion question={question} questionIdx={index} />
          )

        case 3:
          return <TextAnswerQuestion question={question} index={index} />

        case 4:
          return <FillBlankQuestion question={question} index={index} />

        case 5:
          return <MatchingQuestion question={question} index={index} />

        default:
          return null
      }
    }

    return (
      <>
        {getTemplate()}
        {!isLast(values.questions, index) && <div className="form__divider" />}
      </>
    )
  }

  return (
    <Container>
      <Header>
        <p onClick={toggle}>
          Step {stepNumber}
          {!!step.name && !step.unit && ` - ${step.name}`}
        </p>
        <Status>
          {canDelete && !disabled && (
            <button className="btn btn--plain mr8" onClick={processDeleteStep}>
              <DeleteForeverOutlined />
            </button>
          )}

          {!open ? (
            <KeyboardArrowDown className="color-black-38" onClick={toggle} />
          ) : (
            <KeyboardArrowUp className="color-black-38" onClick={toggle} />
          )}
        </Status>
      </Header>
      {open && (
        <Content>
          {!!step.unit && <UnitInfo unit={step.unit} />}

          <ValidatorForm onSubmit={processSaveStep} className="form step-form">
            <div className="form__fieldset">
              <label htmlFor="name" className="form__label">
                Step name *
              </label>
              <div className="form__fieldbox">
                <div className="form__input">
                  <TextValidator
                    id="name"
                    name="name"
                    value={values.name}
                    placeholder="Type step name"
                    className="edit-form__input"
                    margin="normal"
                    fullWidth
                    validators={[
                      "required",
                      "minStringLength:3",
                      "maxStringLength:200",
                    ]}
                    errorMessages={[
                      "Field is required",
                      "Min length is 3 characters",
                      "Max length is 200 characters",
                    ]}
                    withRequiredValidator
                    onChange={handleChange("name")}
                    disabled={disabled}
                  />
                </div>
              </div>
            </div>

            <div className="form__fieldset">
              <label htmlFor="description" className="form__label">
                Instructions
              </label>
              <div className="form__fieldbox">
                <div className="form__input">
                  <TextValidator
                    id="description"
                    name="description"
                    value={values.description}
                    placeholder="Type step instructions"
                    className="edit-form__input"
                    margin="normal"
                    fullWidth
                    multiline
                    validators={["maxStringLength:5000"]}
                    errorMessages={["Max length is 5000 characters"]}
                    withRequiredValidator
                    onChange={handleChange("description")}
                    disabled={disabled}
                  />
                </div>
              </div>
            </div>

            <MultipleTextField
              formIsModal
              values={values.links}
              setValues={(links) => setValues({ ...values, links })}
              limit={5}
              fieldLabel="Links"
              fieldPlaceholder="Type URL"
              addButtonLabel="Add link"
              validators={["isLink", "maxStringLength:250"]}
              validatorMessages={[
                "Invalid URL",
                "Max length is 250 characters",
              ]}
              disabled={disabled}
            />

            <TimeDurationPicker
              label={"Estimated time"}
              time={values.time}
              onChange={(t) =>
                setValues((prevState) => ({
                  ...prevState,
                  time: t,
                }))
              }
              disabled={disabled}
            />

            <StandardPicker
              value={values.standards}
              savedValue={step.standards}
              onChange={(v) =>
                setValues((prevState) => ({ ...prevState, standards: v }))
              }
              disabled={disabled}
            />

            {/*<div className="form__fieldset">*/}
            {/*  <label className="form__label">Standards</label>*/}
            {/*  <div className="form__fieldbox">*/}
            {/*    <div className="form__input form__input--select">*/}
            {/*      <MultiSelect*/}
            {/*        isMulti*/}
            {/*        list={standards.list}*/}
            {/*        defaultValue={*/}
            {/*          (step.standards &&*/}
            {/*            step.standards.map((s) => ({*/}
            {/*              value: s.id,*/}
            {/*              label: s.name,*/}
            {/*            }))) ||*/}
            {/*          undefined*/}
            {/*        }*/}
            {/*        placeholder="Select standards"*/}
            {/*        onScroll={onScroll}*/}
            {/*        onChange={setChosenStandards}*/}
            {/*        onInputChange={setStandardsName}*/}
            {/*        emptyArrayMessage={*/}
            {/*          standards.received ? <span>No results</span> : <Loader />*/}
            {/*        }*/}
            {/*        disabled={disabled}*/}
            {/*      />*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*</div>*/}

            {((values.blobs.length > 0 && disabled) || !disabled) && (
              <div className="form__fieldset">
                <span className="form__label">Attachments</span>
                <div className="form__fieldbox">
                  <div className="form__attachments">
                    <FileLoader
                      attachmentId={`blobs-${stepNumber}`}
                      blobs={
                        values.blobsInfo
                          ? values.blobsInfo.map((b, i) => {
                              return {
                                id: values.blobs[i]
                                  ? values.blobs[i].id
                                  : undefined,
                                name: b.name,
                                lastModified: b.lastModified,
                                lastModifiedDate: b.lastModifiedDate,
                                webkitRelativePath: b.webkitRelativePath,
                                size: b.size,
                                type: b.type,
                                key: b.key,
                              }
                            })
                          : []
                      }
                      onUpload={setBlobs}
                      token={rest.userData.token}
                      attachmentOnly={true}
                      limit={10}
                      disabled={disabled}
                    />

                    {!!values.blobs &&
                      values.blobs.length < 10 &&
                      !disabled && (
                        <Button
                          color="primary"
                          variant="outlined"
                          className={`${!!values.blobs.length ? "mt10" : ""}`}
                          onClick={() =>
                            handleFileInputOpen(`blobs-${stepNumber}`)
                          }
                        >
                          Upload
                        </Button>
                      )}
                  </div>
                </div>
              </div>
            )}

            {/*{((products.dataList.length > 0 && disabled) || !disabled) && (*/}
            {/*  <div className="form__fieldset">*/}
            {/*    <span className="form__label">Products</span>*/}
            {/*    <div className="form__fieldbox">*/}
            {/*      {!!products.dataList && !!products.dataList.length && (*/}
            {/*        <div className="step-products">*/}
            {/*          {products.dataList.map((item) => (*/}
            {/*            <div className="step-products__item" key={item.id}>*/}
            {/*              <img*/}
            {/*                src={item.image || productLogoDefault}*/}
            {/*                alt=""*/}
            {/*                className="step-products__img"*/}
            {/*              />*/}
            {/*              <Link*/}
            {/*                to={generatePath(routes.PRODUCT, {*/}
            {/*                  productId: item.id,*/}
            {/*                })}*/}
            {/*                className="step-products__name"*/}
            {/*              >*/}
            {/*                {item.name}*/}
            {/*              </Link>*/}
            {/*              {!disabled && (*/}
            {/*                <div className="step-products__item-wrapper">*/}
            {/*                  <CloseOutlined*/}
            {/*                    onClick={() => deleteProduct(item.id)}*/}
            {/*                  />*/}
            {/*                </div>*/}
            {/*              )}*/}
            {/*            </div>*/}
            {/*          ))}*/}
            {/*        </div>*/}
            {/*      )}*/}
            {/*      {!!products.dataList &&*/}
            {/*        products.dataList.length < 10 &&*/}
            {/*        !disabled && (*/}
            {/*          <Button*/}
            {/*            variant="outlined"*/}
            {/*            color="primary"*/}
            {/*            onClick={openProductsDialog}*/}
            {/*          >*/}
            {/*            Upload product*/}
            {/*          </Button>*/}
            {/*        )}*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*)}*/}

            {/*<span className={'f mt15 mb15 color-black-54'}>*/}
            {/*  Note: Be sure to ask a question if your next Step will have a live*/}
            {/*  meet. Submitted answers trigger any dynamic meeting set-up.*/}
            {/*</span>*/}

            <div className="form__fieldset mb40">
              <span className="form__label">Questions </span>

              <div className="form__fieldbox">
                <div className="form__input-group">
                  {!values.questions.length && !disabled && (
                    <button
                      type="button"
                      className="form__add-input"
                      onClick={() => handleClickOpen("create")}
                    >
                      <AddOutlined /> Add
                    </button>
                  )}
                </div>
              </div>
            </div>

            {values.questions.map((item, index) => (
              <div
                className="question-container"
                key={item.id || item.title + index}
              >
                {composeQuestionTemplate(item, index)}
                {!disabled && (
                  <div className="question-controls">
                    <button
                      type="button"
                      className="btn btn--plain mr10"
                      onClick={() => handleClickOpen("edit", item, index)}
                    >
                      <EditOutlined />
                    </button>
                    <button
                      className="btn btn--plain mr10"
                      type="button"
                      onClick={() => deleteQuestion(index)}
                    >
                      <DeleteForeverOutlined />
                    </button>
                  </div>
                )}
              </div>
            ))}

            {!!values.questions.length && !disabled && (
              <div className="form__fieldset">
                <span className="form__label"></span>

                <div className="form__fieldbox">
                  <button
                    type="button"
                    className="form__add-input"
                    onClick={() => handleClickOpen("create")}
                  >
                    <AddOutlined /> Add
                  </button>
                </div>
              </div>
            )}
            {!disabled && (
              <Button
                color="primary"
                variant="contained"
                type="submit"
                className="form__submit"
                // disabled={!values.name || (!values.questions.length && !values.blobs.length && !products.list.length)}>Save</Button>
                disabled={!values.name}
              >
                Save
              </Button>
            )}
          </ValidatorForm>
        </Content>
      )}

      {openQuestionDialog && (
        <QuestionForm
          open={openQuestionDialog}
          handleClose={handleClose}
          saveQuestion={(question) =>
            saveQuestion({
              question,
              index: questionToEdit.index,
            })
          }
          question={questionToEdit.question}
        />
      )}

      {products.open && (
        <StepProductsDialog
          open={products.open}
          handleClose={closeProductsDialog}
          addProduct={addProduct}
          deleteProduct={deleteProductFromList}
          stepId={step.id}
          relatedProducts={products.list}
        />
      )}
    </Container>
  )
}

export default withSnackbar(StepForm)
